import React, { FC } from 'react';
import dayjs from '@/shared/lib/dayjs';
import Timer from 'antd/es/statistic/Timer';


interface MyTimerProps{
  date: string;
  onFinish?: () => void;
}

export const MyTimer:FC<MyTimerProps> = ({date,onFinish}) => {
  if(!date) return;
  const deadline = dayjs.tz(date).toString();
  return (
    <Timer type="countdown" value={deadline} format="HH:mm:ss" onFinish={onFinish}/>
  )
};
